<template>
    <div class="m-guide">
        <div class="guide-img"></div>
        <div class="hint">
            <p>如有好友线下的联系方式，可以直接点击【分享按钮】，发送链接给好友，呼唤归来，组队开黑。</p>
            <div class="u-btn btn-share" @click="call_share"></div>
        </div>
    </div>
</template>

<style scoped>
@media screen and (min-device-width: 1025px){
.guide-img{
    width: 1000px;
    height: 658px;
    margin: 0 auto;
    background-image: url(~@/images/img-guide.png);
}

.hint{
    width: 100%;
    margin-top: 30px;
    text-align: center;
    color: #fdf0d5;
    font-size: 14px;
}

.hint p{
    display: inline-block;
}

.btn-share{
    display: inline-block;
    width: 124px;
    height: 35px;
    margin-left: 20px;
    background-image: url(~@/images/btn-invite-share.png);
    vertical-align: middle;
}

.btn-share:hover{
    background-image: url(~@/images/btn-invite-share_hover.png);
}
}

@media screen and (max-device-width: 1024px){
.guide-img{
    width: 670px;
    height: 743px;
    margin: 0 auto;
    background-image: url(~@/images/m/img-guide.png);
}

.hint{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 40px;
    text-align: center;
    color: #fdf0d5;
    font-size: 14px;
}

.hint p{
    width: 392px;
    font-size: 24px;
    text-align: left;
}

.btn-share{
    display: inline-block;
    width: 234px;
    height: 97px;
    background-image: url(~@/images/m/btn-invite-share.png);
    vertical-align: middle;
}

}

</style>

<script>
export default {
    props : {
        ua : {
            default : {},
        },
        login : {
            default : 0,
        }
    },    
    methods : {
        call_share (){

            if(!this.login)return this.$mslogin.open();
            if(!this.ua.areaId)return this.$bind();

            this.$share_modal({
                code : this.ua.inviteCode,
            })
        },        
    },
}
</script>


// WEBPACK FOOTER //
// src/components/guide.vue